module.exports = __webpack_public_path__ + "img/seguridad_industrial.d0490034.jpg";